<template>
    <div class="d-flex align-center">
        <v-chip color="#43A047" dark label small v-if="wallet && wallet.isSignedIn()">
            <icon-base height="25" width="25" viewBox="0 0 180 225" icon-name="near" class="mr-2">
                <icon-near iconColor="rgba(0, 0, 0, 1)" />
            </icon-base>
            <span v-if="!$vuetify.breakpoint.mobile && !shorten" class="font-weight-dark text-uppercase mr-2" style="color: black">Near Wallet Account</span>
            <v-tooltip :disabled="!$vuetify.breakpoint.mobile" top>
                <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" :class="$vuetify.breakpoint.mobile ? 'wallet-account-id' : ''">{{ wallet.getAccountId() }}</span>
                </template>
                <span>{{ wallet.getAccountId() }}</span>
            </v-tooltip>
            <v-btn text light x-small @click="walletDisconnect" class="ml-4">Disconnect</v-btn>
        </v-chip>
        <div v-if="$auth.roles.find(role => role.match(/advanced|collector|admin/i)) || $route.name === 'wishlist'" class="d-flex align-center">
            <v-chip label small v-if="!wallet || !wallet.isSignedIn()">
                <icon-base height="25" width="25" viewBox="0 0 180 225" icon-name="near" class="mr-2">
                    <icon-near iconColor="rgba(0, 0, 0, 1)" />
                </icon-base>
                <span class="font-weight-dark text-uppercase"><span v-if="!$vuetify.breakpoint.mobile && !shorten">Near </span>Wallet <span v-if="!$vuetify.breakpoint.mobile">Account</span></span>
                <v-btn text light x-small @click="walletConnect" class="ml-4">Connect</v-btn>
            </v-chip>
            <v-btn v-if="!shorten && (wallet && !wallet.isSignedIn()) && $route.name === 'account'" text x-small @click="recoverWallet" class="ml-4 d-flex align-center">Recovery</v-btn>
        </div>
    </div>
</template>
<style scoped>
</style>
<script>
const { VUE_APP_NEAR_NFT_CONTRACT_ID } = process.env;

import App from "../App.vue";

export default {
    name: "BnftNearWalletButton",
    extends: {},
    components: {
        ...App.components,
    },
    props: {
        shorten: Boolean,
        contractId: {
            type: String,
            default: VUE_APP_NEAR_NFT_CONTRACT_ID
        }
    },
    methods: {
        async walletConnect() {
            this.wallet = await this.$near.signIn({ contractId: this.contractId });
        },
        async walletDisconnect() {
            this.wallet = await this.$near.signOut({ contractIds: [this.contractId] });
        },
        async recoverWallet() {
            await this.$backend.walletRecovery();
        },
    },
    data: function () {
        return {
            wallet: null,
            accountId: null,
        };
    },
    watch: {
        wallet: {
            deep: true,
            handler(wallet) {
                this.$emit('input', wallet);
            }
        }
    },
    mounted() {
        const self = this;
        self.$emit('input', self.wallet);
        (async () => {
            if (!self.wallet || !self.wallet.isSignedIn()) self.wallet = await self.$near.getWalletConnection(self.contractId);
            self.accountId = await self.wallet.getAccountId();
        })();
    },
};
</script>
